import { render } from "./MemberTab.vue?vue&type=template&id=53039cba&scoped=true"
import script from "./MemberTab.vue?vue&type=script&lang=js"
export * from "./MemberTab.vue?vue&type=script&lang=js"

import "./MemberTab.vue?vue&type=style&index=0&id=53039cba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53039cba"]])

export default __exports__